import { create } from 'zustand'

export const MY_MONITORING_SITE_HOME_VIEW = 'home'

interface IMyMonitoringSiteViewStore {
  viewKey: string
  setViewKey: (viewKey: string) => void
}

export const useMyMonitoringSiteViewStore = create<IMyMonitoringSiteViewStore>((set) => ({
  viewKey: MY_MONITORING_SITE_HOME_VIEW,
  setViewKey: (viewKey: string) => set({ viewKey })
}))
